uniform vec4 u_color;

void main() {
    glFragColor = u_color;
}
